import {
  BaseKit,
  Blockquote,
  Bold,
  BulletList,
  Clear,
  Color,
  createVuetifyProTipTap,
  FontFamily,
  FontSize,
  Highlight,
  History,
  HorizontalRule,
  Indent,
  Italic,
  Link,
  OrderedList,
  Strike,
  Table,
  TaskList,
  TextAlign,
  Underline,
  VuetifyTiptap,
  VuetifyViewer,
} from "vuetify-pro-tiptap";
import "vuetify-pro-tiptap/style.css";
import { Extension } from "@tiptap/core";

const SwapEnterKeys = Extension.create({
  name: "swapEnterKeys",
  priority: 1000,
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () =>
        this.editor.commands.first(({ commands }) => [
          () => commands.splitListItem("listItem"),
          () => commands.splitListItem("taskItem"),
          () => commands.newlineInCode(),
          () => commands.createParagraphNear(),
          () => commands.liftEmptyBlock(),
          () => commands.splitBlock(),
        ]),
    };
  },
});

const DISABLED_FORMATTING_SHORTCUTS = [
  "Mod-Shift-s",
  "Mod-Shift-7",
  "Mod-Shift-9",
  "Mod-Shift-b",
  "Mod-Shift-l",
  "Mod-Shift-e",
  "Mod-Shift-r",
  "Mod-Shift-j",
];

const DisableFormattingShortcuts = Extension.create({
  name: "disableFormattingShortcuts",
  priority: 1000,
  addKeyboardShortcuts() {
    return Object.fromEntries(DISABLED_FORMATTING_SHORTCUTS.map((shortcut) => [shortcut, () => true]));
  },
});

// @ts-ignore
export const vuetifyProTipTap = createVuetifyProTipTap({
  lang: "en",
  fallbackLang: "en",
  markdownTheme: "omni",
  components: {
    VuetifyTiptap,
    VuetifyViewer,
  },
  extensions: [
    BaseKit.configure({
      placeholder: {
        placeholder: "Enter some text...",
      },
    }),
    Bold,
    Italic,
    Underline,
    Strike,
    // Code.configure({ divider: true }),
    // Heading,
    TextAlign,
    FontFamily,
    FontSize,
    Color,
    Highlight.configure({ divider: true }),
    // SubAndSuperScript.configure({ divider: true }),
    Clear.configure({ divider: true }),
    BulletList,
    OrderedList,
    TaskList,
    Indent.configure({ divider: true }),
    Link,
    Table.configure({ divider: true }),
    Blockquote,
    HorizontalRule,
    // CodeBlock.configure({ divider: true }),
    History.configure({ divider: true }),
    // Fullscreen,
    SwapEnterKeys,
    DisableFormattingShortcuts,
  ],
});
